import React from 'react';
import { type ActiveInstantiatedPlan, queueLocalUnsubscribe } from '@soulhx/client-store';
import { getIpDateRange, getIpStats, minifiedVersion } from '@soulhx/fs-common';
import { StandardButton } from '@soulhx/ui-common';
import { DateTime } from 'luxon';
import { ListGroup, ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const formatDate = (date: string) => DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED);

interface ISubscribedPlanItem {
  subscription: ActiveInstantiatedPlan;
  today: string;
  compact?: boolean;
  variant?: string;
}
export const SubscribedPlanItem = ({ subscription, today, compact = false, variant }: ISubscribedPlanItem) => {
  const { t } = useTranslation(['plan']);
  const { ip, plan, days } = subscription;
  const range = getIpDateRange(days);
  const { percentComplete } = getIpStats(days, today);
  const percent = Math.round(percentComplete * 100);

  return (
    <ListGroup.Item className="d-flex align-items-center gap-2">
      <div className="flex-grow-1">
        {!compact && (
          <div>
            <strong>{plan?.name ?? t('plan:subscriptions.loadingName')}</strong>
            {plan && (
              <span className="text-secondary ms-2">
                {t('plan:summary.versionBadge', { version: minifiedVersion(plan.version) })}
              </span>
            )}
          </div>
        )}
        {range && (
          <div className="text-secondary small">
            {t('plan:subscriptions.dateRange', { start: formatDate(range.start), end: formatDate(range.end) })}
          </div>
        )}
        <ProgressBar
          now={percent}
          label={t('plan:summary.progressBarLabel', { percentComplete: percent })}
          className="mt-1"
          variant={variant}
        />
      </div>
      <StandardButton
        type="delete"
        itemType={t('plan:subscriptions.itemType')}
        onClick={() => {
          void queueLocalUnsubscribe(ip.id);
        }}
        variant={variant ? `outline-${variant}` : undefined}
      />
    </ListGroup.Item>
  );
};

export default SubscribedPlanItem;
